import React from 'react'
import './competition.scss'
import { LOCALE, urlMuestreo } from '../../../constants/activity-constants'
import { siteUrl } from '../../../shared/utils/siteUrl'

import iconNumero1 from '../../../assets/images/iconNumero1.png'
import iconNumero2 from '../../../assets/images/iconNumero2.png'
import iconNumero3 from '../../../assets/images/iconNumero3.png'

const Competition = () => {
  const urlMuestra =
    LOCALE === 'es-CL'
      ? siteUrl +
        '/productos/durante-tu-periodo/toallas-higienicas/calzon-nocturno-nosotras-maxima-proteccion/'
      : siteUrl +
        '/productos/durante-tu-periodo/toallas-higienicas/toallas-buenas-noches-maxima-proteccion/'

  const precioMuestra = {
    'es-CO': '20',
    'es-EC': '50',
  }[LOCALE || 'es-CO']

  const textInfoPremio = {
    'es-CO': [
      <>
        Sé una de las 500 ganadoras y recibe en casa una muestra de las nuevas
        Toallas Nosotras Buenas Noches Máxima Protección, acompañada de una
        espectacular cobija.
      </>,
    ],
    'es-CL': [
      <>
        Sé una de las 500 ganadoras y recibe en casa una muestra del nuevo
        Calzón Nocturno Buenas Noches Máxima Protección, acompañado de una
        espectacular cobija.
      </>,
    ],
    'es-EC': [
      <>
        Sé una de las 500 ganadoras y recibe en casa una muestra del nuevo
        Calzón Nocturno Buenas Noches Máxima Protección, acompañado de una
        espectacular antifaz y moño Nosotras.
      </>,
    ],
  }[LOCALE || 'es-CO']

  return (
    <div className='f-competition'>
      <div id='competition' className='f-competition__ancla' />

      <div className='f-competition__content'>
        <div className='f-competition__content-info'>
          <h2>Participa y gana una muestra</h2>
          <p>{textInfoPremio}</p>
        </div>

        <div className='f-competition__content-list'>
          <div className='f-competition__content-list__step'>
            <img src={iconNumero1} alt='icon numero 1' />
            <div className='f-competition__content-list__step-text'>
              <h3>Inicia sesión o regístrate</h3>
            </div>
          </div>

          <div className='f-competition__content-list__step'>
            <img src={iconNumero2} alt='icon numero 2' />
            <div className='f-competition__content-list__step-text'>
              <h3>Redime {precioMuestra} puntos cada vez que quieras participar</h3>
            </div>
          </div>

          <div className='f-competition__content-list__step'>
            <img src={iconNumero3} alt='icon numero 3' />
            <div className='f-competition__content-list__step-text'>
              <h3>Participa y si tienes la mejor respuesta, ¡ganas!</h3>
            </div>
          </div>
        </div>
        <a href={urlMuestreo} target='_blank'>
          <button
            onClick={() => {
              try {
                window.dataLayer.push({
                  event: 'ga_event',
                  category: 'ui :: landing :: concurso',
                  action: 'click',
                  label: 'participa',
                  value: '',
                })
              } catch (error) {
                console.log(error)
              }
              window.open(urlMuestra, '_blank')
            }}
          >
            Participa
          </button>
        </a>
      </div>
    </div>
  )
}

export default Competition
